import React, { useEffect, useState, Fragment } from "react";
import MainContent from "../../../layouts/maincontent/MainContent";
import InputElement from "../../form/InputElement";
import validateProfile, {
  validateProfileFields,
} from "../../../validations/ValidateProfile";
import styleProfile from "./UserProfile.module.css";
import { getUser } from "../../../adapters/apis/auth/auth";
import {
  getDsiputePreviewFiles,
  getGovernorates,
} from "../../../adapters/apis/lookups/lookups";
import { edit_profile } from "../../../adapters/apis/auth/auth";
import useFileHandler from "../../../hooks/useFileHandler";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

function UserProfile() {
  const { handlePreviewClick } = useFileHandler();
  const navigate = useNavigate();
  const user_data = {
    id: "",
    profile_id: "",
    first_name: "",
    second_name: "",
    third_name: "",
    fourth_name: "",
    email: "",
    phone_number: "",
    nationality: {
      key: "",
      value: "",
    },
    password: "",
    confirm_password: "",
    national_id: "",
    passport_number: "",
    governorate_id: "",
    national_id_file: "",
    passport_number_file: "",
  };
  const [user, setUser] = useState({
    ...user_data,
    nationality: { key: "EG", value: "مصر" },
  });
  const [initialUser, setInitialUser] = useState({
    ...user_data,
    nationality: { key: "EG", value: "مصر" },
  });

  const [error_user, setUserError] = useState({
    ...user_data,
    nationality: "",
  });
  const [disabled, setDisabled] = useState(true);
  const [nationalIdFileUpload, setNationalIdFileUpload] = useState(null);
  const [govs, setGovs] = useState([]);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    getUser()
      .then((res) => {
        const userData = res.data.data;
        const mappedUser = {
          id: userData.id,
          profile_id: userData.profile.id,
          first_name: userData.profile.first_name,
          second_name: userData.profile.second_name,
          third_name: userData.profile.third_name,
          fourth_name: userData.profile.fourth_name,
          email: userData.email,
          phone_number: userData.profile.mobile,
          nationality: {
            key: userData.profile.nationality.code,
            value: userData.profile.nationality.name,
          },
          national_id: userData.profile.national_id,
          passport_number: userData.profile.passport_num,
          governorate_id: userData.profile.governorate_id,
          national_id_file: userData.profile.national_id_file
            ? userData.profile.national_id_file[0]
            : null,
          passport_number_file: userData.profile.passport_num_file
            ? userData.profile.passport_num_file[0]
            : null,
        };

        setUser(mappedUser);
        setInitialUser(mappedUser);
        getGovernorates()
          .then((res) => {
            setGovs(res.data.data);
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  function handleChange(parentCompenent, compenent, key, value) {
    validateProfileFields(setError, user, key, value);
    setUser((prev) => ({
      ...prev,
      [key]: value,
    }));
  }
  function setError(key, value) {
    setUserError((prev) => ({
      ...prev,
      [key]: value,
    }));
  }

  function changeProfile() {
    const valid = validateProfile(setError, user);
    if (valid) {
      const data = new FormData();
      // data.append("first_name", user.first_name);
      // data.append("second_name", user.second_name);
      // data.append("third_name", user.third_name);
      // data.append("fourth_name", user.fourth_name);
      data.append("email", user.email);
      data.append("mobile", user.phone_number);
      if (user?.nationality?.key === "EG") {
        data.append("national_id", user.national_id || "");
        if (nationalIdFileUpload) {
          data.append("national_id_file", nationalIdFileUpload);
        }
      }
      if (
        user?.nationality?.key !== "EG" &&
        ![null, "", undefined, "null"].includes(user.passport_number)
      ) {
        data.append("passport_num", user.passport_number);
      }
      // data.append("factory_num", user.factory_num);
      data.append("nationality_code", user?.nationality?.key);
      data.append("governorate_id", user.governorate_id);

      edit_profile(data)
        .then(() => {
          setUserError({ ...user_data, nationality: "" });
          setDisabled(true);
          setInitialUser(user);
          setNationalIdFileUpload(null);
          setSuccess(true);
        })
        .catch((err) => {
          if (!err?.response) {
            console.log("No Server Response");
          } else if (err.response?.status === 500) {
            console.log("server error: ", err.response.data.message);
          } else if (err.response?.status === 422) {
            if (err?.response?.data?.errors) {
              Object.keys(err.response.data.errors).forEach((key) => {
                setError(key, err.response.data.errors[key][0]);
              });
            }
          } else {
            console.log("unknown error: ", err.response);
          }
          setSuccess(false);
          setDisabled(false);
        });
    }
  }

  function handleEnableEdit() {
    setSuccess(false);
    setDisabled(false);
  }

  function handleCancelEdit() {
    setUser(initialUser);
    setUserError({ ...user_data, nationality: "" });
    setNationalIdFileUpload(null);
    setSuccess(false);
    setDisabled(true);
  }

  const governorateName =
    govs.find((gov) => parseInt(gov.id) === parseInt(user.governorate_id))
      ?.name ?? "";

  const getBirthDateFromNationalId = (nationalId) => {
    if (!/^\d{14}$/.test(String(nationalId ?? ""))) {
      return "";
    }

    const idAsText = String(nationalId);
    const centuryCode = parseInt(idAsText.charAt(0));
    const year = parseInt(idAsText.slice(1, 3));
    const month = parseInt(idAsText.slice(3, 5));
    const day = parseInt(idAsText.slice(5, 7));

    if (
      ![2, 3].includes(centuryCode) ||
      month < 1 ||
      month > 12 ||
      day < 1 ||
      day > 31
    ) {
      return "";
    }

    const fullYear = `${centuryCode === 2 ? 19 : 20}${year
      .toString()
      .padStart(2, "0")}`;

    return `${day}/${month}/${fullYear}`;
  };

  const getGenderFromNationalId = (nationalId) => {
    if (!/^\d{14}$/.test(String(nationalId ?? ""))) {
      return "";
    }

    return parseInt(String(nationalId).charAt(12)) % 2 === 0 ? "أنثى" : "ذكر";
  };

  const birthDate = getBirthDateFromNationalId(user.national_id);
  const gender = getGenderFromNationalId(user.national_id);
  const remainingName = [user.second_name, user.third_name, user.fourth_name]
    .filter((namePart) => !!namePart)
    .join(" ");

  return (
    <MainContent>
      <section className={`${styleProfile["section-content"]} section-content`}>
        <div className={`${styleProfile.container} container`}>
          <div className={`${styleProfile["card-box"]} card-box pb-5`}>
            <div className={`${styleProfile["box-content"]} box-content`}>
              <div className={`${styleProfile.box} box`}>
                {disabled && (
                  <>
                    <div className={styleProfile.editHeaderRow}>
                      <i
                        className="fa-solid fa-arrow-right"
                        aria-hidden="true"
                        onClick={() => navigate("/user-settings")}
                      ></i>
                      <h4
                        className={`${styleProfile["box-title"]} box-title mb-0`}
                      >
                        إدارة حساب المستخدم
                      </h4>
                    </div>
                  </>
                )}

                {!disabled && (
                  <>
                    <div className={styleProfile.editHeaderRow}>
                      <i
                        className="fa-solid fa-arrow-right"
                        aria-hidden="true"
                        onClick={handleCancelEdit}
                      ></i>
                      <h4
                        className={`${styleProfile["box-title"]} box-title mb-0`}
                      >
                        تعديل بيانات حساب المستخدم
                      </h4>
                    </div>
                  </>
                )}

                {success && (
                  <div className="alert alert-primary" role="alert">
                    تم تعديل البيانات الشخصية بنجاح
                  </div>
                )}
                <div className={`row ${styleProfile.profileGrid}`}>
                  <div className="col-lg-4 col-md-6">
                    <InputElement
                      mb4="mb-4"
                      labelHtmlFor="first_name"
                      labelClassName={`  ${styleProfile["form-label"]} form-label`}
                      labelText="الإسم الأول للمستخدم"
                      inputType="text"
                      name="first_name"
                      inputClassName={`${styleProfile["form-control"]} form-control`}
                      inputID="first_name"
                      pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                      disabled
                      pText={error_user.first_name}
                      value={user.first_name}
                      onChange={handleChange}
                      maxLength={255}
                    />
                  </div>
                  <div className="col-lg-4 col-md-6">
                    <InputElement
                      mb4="mb-4"
                      labelHtmlFor="second_name"
                      labelClassName={`  ${styleProfile["form-label"]} form-label`}
                      labelText="باقي اسم المستخدم"
                      inputType="text"
                      name="second_name"
                      inputClassName={`${styleProfile["form-control"]} form-control`}
                      inputID="second_name"
                      pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                      disabled
                      pText={error_user.second_name}
                      value={remainingName}
                      onChange={handleChange}
                      maxLength={255}
                    />
                  </div>
                  <div className="col-lg-4 col-md-6">
                    <InputElement
                      mb4="mb-4"
                      labelHtmlFor="natioanlity"
                      labelClassName={`  ${styleProfile["form-label"]} form-label`}
                      labelText="الجنسية"
                      inputType="text"
                      name="natioanlity"
                      inputClassName={`${styleProfile["form-control"]} form-control`}
                      inputID="natioanlity"
                      pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                      disabled
                      pText={error_user.nationality}
                      value={user.nationality.value}
                      onChange={handleChange}
                      maxLength={255}
                    />
                  </div>

                  {user.nationality.key === "EG" ? (
                    <Fragment>
                      <div className="col-lg-4 col-md-6">
                        <div className="mb-4">
                          <label
                            htmlFor="national_id"
                            className={` ${styleProfile["form-label"]} form-label`}
                          >
                            الرقم القومي
                          </label>
                          <div className={styleProfile.verifyInputGroup}>
                            <input
                              id="national_id"
                              type="text"
                              className={`${styleProfile["form-control"]} form-control`}
                              value={user.national_id || ""}
                              disabled={disabled}
                              maxLength={14}
                              onChange={(e) =>
                                handleChange(
                                  "",
                                  "",
                                  "national_id",
                                  e.target.value,
                                )
                              }
                            />
                            {disabled && (
                              <button
                                type="button"
                                className={styleProfile.verifyButton}
                              >
                                التحقق من الرقم القومي
                              </button>
                            )}
                          </div>
                          {error_user.national_id && (
                            <p className="text-danger mb-0 mt-2 me-2 fw-bolder">
                              {error_user.national_id}
                            </p>
                          )}
                        </div>
                      </div>
                      {disabled &&
                        user.national_id_file &&
                        user.national_id_file.full_url && (
                          <div className="col-lg-4 col-md-6">
                            <InputElement
                              value={"الملف"}
                              disabled={true}
                              name="national_id_file"
                              mb4="mb-4"
                              labelHtmlFor="national_id_file"
                              labelClassName={` ${styleProfile["form-label"]} form-label`}
                              labelText="مرفق الرقم القومي"
                              inputType="text"
                              inputClassName={`${styleProfile["form-control"]} form-control`}
                              inputID="national_id_file_input"
                              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                              isIcon={
                                user?.national_id_file?.url ||
                                user?.national_id_file?.full_url ||
                                ""
                              }
                              idDownload={user?.profile_id}
                              filedDownload="nationalIdFile"
                            />
                          </div>
                        )}

                      {!disabled &&
                        user.national_id_file &&
                        user.national_id_file.full_url && (
                          <div className="col-lg-4 col-md-6">
                            <InputElement
                              value={"الملف"}
                              disabled={true}
                              name="national_id_file"
                              mb4="mb-4"
                              labelHtmlFor="national_id_file"
                              labelClassName={` ${styleProfile["form-label"]} form-label`}
                              labelText="مرفق الرقم القومي"
                              inputType="text"
                              inputClassName={`${styleProfile["form-control"]} form-control`}
                              inputID="national_id_file_input"
                              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                              isIcon={
                                user?.national_id_file?.url ||
                                user?.national_id_file?.full_url ||
                                ""
                              }
                              idDownload={user?.profile_id}
                              filedDownload="nationalIdFile"
                            />
                          </div>
                        )}
                    </Fragment>
                  ) : (
                    <Fragment>
                      <div className="col-lg-4 col-md-6">
                        <InputElement
                          mb4="mb-4"
                          labelHtmlFor="passport_number"
                          labelClassName={` ${styleProfile["form-label"]} form-label`}
                          labelText="رقم جواز السفر (كما هو مدون بجواز السفر)"
                          inputType="text"
                          name="passport_number"
                          inputClassName={`${styleProfile["form-control"]} form-control`}
                          inputID="passport_number"
                          pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                          disabled
                          pText={error_user.passport_num}
                          value={user.passport_number}
                          onChange={handleChange}
                          maxLength={255}
                        />
                      </div>
                      <div className="col-lg-4 col-md-6">
                        {user.passport_number_file &&
                          user.passport_number_file.full_url && (
                            <div className="mb-4">
                              <label className="form-label">
                                ملف جواز السفر
                              </label>
                              <button
                                className="btn btn-primary d-block py-2 btn-view w-100"
                                onClick={() =>
                                  handlePreviewClick(
                                    user.profile_id,
                                    "passportNumFile",
                                    getDsiputePreviewFiles,
                                  )
                                }
                              >
                                <i className="fa-solid fa-file-image fa-fw fa-lg"></i>
                                ملف جواز السفر
                              </button>
                            </div>
                          )}
                      </div>
                    </Fragment>
                  )}

                  <div className="col-lg-4 col-md-6">
                    <div className="mb-4">
                      <label
                        htmlFor="phone_number"
                        className={` ${styleProfile["form-label"]} form-label`}
                      >
                        رقم الهاتف المحمول
                      </label>
                      <div className={styleProfile.verifyInputGroup}>
                        <input
                          id="phone_number"
                          type="text"
                          className={`${styleProfile["form-control"]} form-control`}
                          value={user.phone_number || ""}
                          disabled={disabled}
                          onChange={(e) =>
                            handleChange("", "", "phone_number", e.target.value)
                          }
                        />
                        {disabled && (
                          <button
                            type="button"
                            className={styleProfile.verifyButton}
                          >
                            التحقق من رقم الهاتف
                          </button>
                        )}
                      </div>
                      {error_user.phone_number && (
                        <p className="text-danger mb-0 mt-2 me-2 fw-bolder">
                          {error_user.phone_number}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6">
                    <div className="mb-4">
                      <label
                        htmlFor="birth_date"
                        className={`${styleProfile["form-label"]} form-label`}
                      >
                        تاريخ الميلاد
                      </label>
                      <input
                        id="birth_date"
                        type="text"
                        className={`${styleProfile["form-control"]} form-control`}
                        value={birthDate}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6">
                    <div className="mb-4">
                      <label
                        htmlFor="birth_place"
                        className={`${styleProfile["form-label"]} form-label`}
                      >
                        محل الميلاد
                      </label>
                      <input
                        id="birth_place"
                        type="text"
                        className={`${styleProfile["form-control"]} form-control`}
                        value={governorateName}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6">
                    <div className="mb-4">
                      <label
                        htmlFor="gender"
                        className={`${styleProfile["form-label"]} form-label`}
                      >
                        النوع
                      </label>
                      <input
                        id="gender"
                        type="text"
                        className={`${styleProfile["form-control"]} form-control`}
                        value={gender}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6">
                    <div className="mb-4">
                      <label
                        htmlFor="email"
                        className={` ${styleProfile["form-label"]} form-label`}
                      >
                        البريد الإلكتروني
                      </label>
                      <div className={styleProfile.verifyInputGroup}>
                        <input
                          id="email"
                          type="email"
                          className={`${styleProfile["form-control"]} form-control`}
                          value={user.email || ""}
                          disabled={disabled}
                          onChange={(e) =>
                            handleChange("", "", "email", e.target.value)
                          }
                        />
                        {disabled && (
                          <button
                            type="button"
                            className={styleProfile.verifyButton}
                          >
                            التحقق من البريد الإلكتروني
                          </button>
                        )}
                      </div>

                      {error_user.email && (
                        <p className="text-danger mb-0 mt-2 me-2 fw-bolder">
                          {error_user.email}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="btn-myProfile d-flex justify-content-start flex-md-row flex-column gap-lg-3 gap-3  align-items-center mt-4">
                    {disabled ? (
                      <>
                        <button
                          type="button"
                          onClick={handleEnableEdit}
                          className={`${styleProfile["btn-edit"]} ${styleProfile["btn-edit-arrow"]}`}
                        >
                          <span className={styleProfile["btn-edit-text"]}>
                            تعديل بيانات حساب المستخدم
                          </span>
                        </button>
                        <Link
                          to="/set-password"
                          className={styleProfile["btn-cancle"]}
                        >
                          تغيير كلمة المرور
                        </Link>
                      </>
                    ) : (
                      <>
                        <button
                          type="button"
                          onClick={changeProfile}
                          className={styleProfile["btn-edit"]}
                        >
                          حفظ التعديلات
                        </button>
                        <button
                          type="button"
                          onClick={handleCancelEdit}
                          className={styleProfile["btn-cancle"]}
                        >
                          إلغاء
                        </button>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </MainContent>
  );
}

export default UserProfile;
